import {
  makePaymentModalFooterElem,
  makePaymentModalFooterContinueContainerElem,
  makePaymentModalFooterContinueElem,
  makePaymentModalFooterPayContainerElem,
  makePaymentModalFooterPayElem,
  makePaymentModalFooterBackContainerElem,
  makePaymentModalFooterBackElem,
  makePaymentProviderData
} from './constants'
import { aptexxModalImplementation } from '../dashboard/constants'
import paymentModalIframeDisplay from './display'

// FSPay
export function paymentModalFooterBackAttach () {
  makePaymentModalFooterBackElem.on('click', function (evt) {
    evt.preventDefault()

    paymentModalIframeDisplay(false)
    paymentModalFooterButtons(true, true)
  })
}

export function paymentModalFooterContinueAttach () {
  makePaymentModalFooterContinueElem.on('click', function (evt) {
    evt.preventDefault()

    paymentModalIframeDisplay(true)
    paymentModalFooterButtons(true, false)
  })
}

// Aptexx
export function paymentModalFooterPayAttach () {
  makePaymentModalFooterPayElem.on('click', function (evt) {
    evt.preventDefault()

    if (aptexxModalImplementation === "true") {
      paymentModalIframeDisplay(true)
      paymentModalFooterButtons(true, false)
    } else {
      const makePaymentAptexxUrlData = makePaymentModalFooterElem.attr('data-payment-url')
      window.open(makePaymentAptexxUrlData, '_blank')
    }
  })
}

export function paymentModalFooterButtons (show = false, continueBtn = true) {
  if (continueBtn) {
    if (makePaymentProviderData === 'aptexx') {
      makePaymentModalFooterContinueContainerElem.addClass('hide')
      makePaymentModalFooterPayContainerElem.removeClass('hide')
      makePaymentModalFooterBackContainerElem.addClass('hide')
    } else {
      makePaymentModalFooterContinueContainerElem.removeClass('hide')
      makePaymentModalFooterPayContainerElem.addClass('hide')
      makePaymentModalFooterBackContainerElem.addClass('hide')
    }
  } else {
    makePaymentModalFooterContinueContainerElem.addClass('hide')
    makePaymentModalFooterPayContainerElem.addClass('hide')
    makePaymentModalFooterBackContainerElem.removeClass('hide')
  }

  if (show) {
    makePaymentModalFooterElem.removeClass('hide')
  } else {
    makePaymentModalFooterElem.addClass('hide')
  }
}
